<template>
  <div class="sidebar-bar-item" :class="{ active: active }" v-on="$listeners">
    <font-awesome-icon class="icon" :icon="icon" />
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: Array,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.sidebar-bar-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  border-radius: 6px;
  cursor: pointer;
  &:hover,
  &:active {
    color: $coral;
    background-color: $light-gray;
  }
}

.active {
  color: $coral;
}
</style>
